module.exports = __webpack_public_path__ + "static/media/pill2.1e294e70.png";